import React, { Component } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { Grid } from '@alifd/next';
import Footer from './components/Footer';
import Intro from './components/Intro';
import routerData from '@/routerConfig';
// import { loginBg } from '@/assets';
import { getAuthority } from '@/utils';
const { Row, Col } = Grid;

const styles = {
    container: {
        position: 'relative',
        width: '100wh',
        minWidth: '1200px',
        height: '100vh',
        // backgroundImage: `url(${loginBg})`,
        backgroundSize: 'cover',
        display: 'flex',
        flexDirection: 'column',
    },
    mask: {
        position: 'absolute',
        left: '0',
        right: '0',
        top: '0',
        bottom: '0',
        background: '#000',
        opacity: '0.4',
    },
    row: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flex: '1',
    },
    form: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
};

export default class UserLayout extends Component {
    render() {
        return (
            <div style={styles.container}>
                <div style={styles.mask} />
                <Row wrap style={styles.row}>
                    <Col l="12">
                        <Intro />
                    </Col>
                    <Col l="12">
                        <div style={styles.form}>
                            <Switch>
                                {routerData.map((item, index) => {
                                    const { path, component, exact, authority } = item;
                                    const authorized = authority && getAuthority();

                                    if (authorized && path.indexOf('/user/login') !== -1) {
                                        return (
                                            <Redirect
                                                key={path}
                                                to={{
                                                    pathname: '/',
                                                }}
                                            />
                                        );
                                    } else {
                                        return component ? (
                                            <Route
                                                key={path}
                                                path={path}
                                                component={component}
                                                exact={exact}
                                                render={(props) => {
                                                    return authorized ? (
                                                        <Component {...props} />
                                                    ) : (
                                                        <Redirect exact from="/user" to="/user/login" />
                                                    );
                                                }}
                                            />
                                        ) : null;
                                    }
                                })}
                            </Switch>
                        </div>
                    </Col>
                </Row>
                <Footer />
            </div>
        );
    }
}
